import { render, staticRenderFns } from "./FillPhoneIcon.vue?vue&type=template&id=dd85a788&"
import script from "./FillPhoneIcon.vue?vue&type=script&lang=js&"
export * from "./FillPhoneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports